import BaseComponents from '@components/global-install.js'
import FreebeComponents from '@freebe/design'

export function useComponents (app) {
  app.use(BaseComponents)
  app.use(FreebeComponents)
}